// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__fJMco","Open":"SideDrawer_Open__1zH1u","Closed":"SideDrawer_Closed__2sQjD","Logo":"SideDrawer_Logo__2F7Ku"};